import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import LoginPage from "./pages/login/LoginPage";
import SignUpPage from "./pages/signup/SignUpPage";
import ForgotPasswordPage from "./pages/forgot-password/ForgotPasswordPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import SettingsPage from "./pages/settings/SettingsPage";
import StoreSettingsPage from "./pages/store/StoreSettingsPage";
import CategoriesPage from "./pages/categories/CategoriesPage";
import ProductsPage from "./pages/products/ProductsPage";
import ProductNewPage from "./pages/products/ProductNewPage";
import ProductEditPage from "./pages/products/ProductEditPage";
import AnalyticsPage from "./pages/analytics/AnalyticsPage";
import InsumosPage from "./pages/insumos/InsumosPage";
import StorefrontLayout from "./pages/storefront/StorefrontLayout";
import StorefrontPage from "./pages/storefront/StorefrontPage";
import ProductDetailPage from "./pages/storefront/ProductDetailPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="store/settings" element={<StoreSettingsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="products/new" element={<ProductNewPage />} />
        <Route path="products/:id/edit" element={<ProductEditPage />} />
        <Route path="insumos" element={<InsumosPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="/stores/:storeSlug" element={<StorefrontLayout />}>
        <Route index element={<StorefrontPage />} />
        <Route path="categories/:categorySlug" element={<StorefrontPage />} />
        <Route path="products/:productSlug" element={<ProductDetailPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
